import Vue from 'vue'

import { show, edit, create, remove } from './itemPriceServices'

const state = {
  itemPrice: {},
  isItemPriceLoading: false,
}

const getters = {
  itemPrice: (state) => state.itemPrice,
  isItemPriceLoading: (state) => state.isItemPriceLoading,
}

const actions = {
  async fetchItemPrice({ commit, dispatch }, id) {
    commit('setIsItemPriceLoading', true)

    try {
      const { data } = await show(id)
      commit('setItemPrice', data)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsItemPriceLoading', false)
    }
  },

  async addItemPrice({ commit, dispatch, rootState }, itemPrice) {
    commit('setIsItemPriceLoading', true)

    try {
      await create(itemPrice)
      commit('setItem', {})
      commit('closeAllModals')
      dispatch('fetchPriceTable', rootState?.priceTable?.priceTableId)

      dispatch(
        'showSuccessMessage',
        Vue.i18n.translate(
          itemPrice.id
            ? 'itemPrice.messages.successfullyUpdated'
            : 'itemPrice.messages.successfullyCreated'
        )
      )
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsItemPriceLoading', false)
    }
  },

  async updateItemPrice({ commit, dispatch }, itemPrice) {
    commit('setIsItemPriceLoading', true)

    try {
      await edit(itemPrice)
      commit('setItem', {})
      commit('closeAllModals')
      dispatch('fetchPriceTable', rootState?.priceTable?.priceTableId)
      dispatch(
        'showSuccessMessage',
        Vue.i18n.translate('itemPrice.messages.successfullyUpdated')
      )
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsItemPriceLoading', false)
    }
  },

  async removeItemPrice({ commit, dispatch, rootState }, id) {
    commit('setIsItemPriceLoading', true)

    try {
      await remove(id)
      commit('closeAllModals')
      dispatch('fetchPriceTable', rootState?.priceTable?.priceTableId)
      dispatch(
        'showSuccessMessage',
        Vue.i18n.translate('itemPrice.messages.successfullyDeleted')
      )
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsItemPriceLoading', false)
    }
  },

  handleOpenCreateEditItemPriceModal({ dispatch, commit }, itemPriceId) {
    commit('setItemPrice', null)
    dispatch('openModal', 'CREATE_ITEM_PRICE_MODAL')
    itemPriceId && dispatch('fetchItemPrice', itemPriceId)
  },

  handleDeleteItemPriceModal({ dispatch, commit }, itemId) {
    commit('setItemPrice', null)
    dispatch('openModal', 'DELETE_ITEM_PRICE_MODAL')
    itemId && dispatch('fetchItemPrice', itemId)
  },
}

const mutations = {
  setItemPrice: (state, itemPrice) => {
    state.itemPrice = itemPrice
  },

  setIsItemPriceLoading: (state, status) => {
    state.isItemPriceLoading = status
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
